var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[
    'label font-weight-bold label-lg label-inline',
    _vm.status ? 'label-light-success' : 'label-light-danger'
  ]},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }